/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Token64LengthType } from '../../models/token-64-length-type';
import { TourWalletInviteData } from '../../models/tour-wallet-invite-data';

export interface ExternalGetTourWalletInviteData$Params {
  token: Token64LengthType;
}

export function externalGetTourWalletInviteData(http: HttpClient, rootUrl: string, params: ExternalGetTourWalletInviteData$Params, context?: HttpContext): Observable<StrictHttpResponse<TourWalletInviteData>> {
  const rb = new RequestBuilder(rootUrl, externalGetTourWalletInviteData.PATH, 'get');
  if (params) {
    rb.query('token', params.token, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TourWalletInviteData>;
    })
  );
}

externalGetTourWalletInviteData.PATH = '/external/tour/wallet-invite';
